(function () {

 'use strict';

  angular.module('eclipseApp.core').filter('sceHtmlWithNoFilter', ['$sce', function($sce) {
    return function (escapedhtml) {
      return $sce.trustAsHtml(escapedhtml);
    }
  }]);

})();
